'use strict';

var util = require('../util/util');
var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch() {
    return window.jRes.isXSmall || window.jRes.isSmall;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch()) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    var $suggestions = $('.suggestions');
    var $searchField = $('input.search-field');
    var $suggestionWrapper = $('.suggestions-wrapper');
    var $resetButton = $('.site-search .reset-button');

    $searchField.val('');
    clearModals();

    if (isMobileSearch()) {
        $suggestions.unbind('scroll');
    }

    $suggestionWrapper.empty();
    $resetButton.removeClass('d-block');
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch()) {
        var $stickyHeader = $('.js-sticky-header');
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');

        if ($stickyHeader.hasClass('is_stuck')) {
            top = $stickyHeader.outerHeight() - outerHeight;
        }

        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-block');
        positionSuggestions(this);

        if (isMobileSearch()) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        $(scope).siblings('.reset-button').removeClass('d-block');
        clearModals();
        getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

function openMobileSearchOverlay() {
    var $suggestions = $('.suggestions');
    var $searchContainer = $('.js-search-container');
    var $stickyHeader = $('.js-sticky-header.is_stuck');
    var $stickyPromoBanner = $('.js-promo-banner.is_stuck');

    if ($searchContainer.length === 0) {
        return;
    }

    $searchContainer.toggleClass('d-none').toggleClass('bbw-search-opened');
    $('.checkout-continue').toggle(10);

    $suggestions.hide();
    tearDownSuggestions();
    util.removeBackdrop('bbw-search-backdrop');

    if (!$searchContainer.hasClass('bbw-search-opened')) {
        $('body').trigger('stickyHeader:start');
        $('.js-sticky-header, .js-promo-banner').trigger('sticky_kit:recalc');
    }

    if ($searchContainer.is(':visible')) {
        util.addBackdrop({specificClass: 'bbw-search-backdrop' });
        if ($('.js-search-container').length > 0) {
            util.trapFocusInsideModal($('.js-search-container')[0]);
        }

        $stickyPromoBanner.trigger('sticky_kit:detach');
        $stickyHeader.trigger('sticky_kit:recalc');

        $('.search-field').focus();
    }
}

module.exports = {
    api: {
        openMobileSearchOverlay
    },
    init() {
        // Cache
        var $body = $('body');
        var $document = $(document);
        var $simpleSearch = $('form[name="simpleSearch"]');
        var $searchFields = $('input.search-field');
        var $resetButton = $('.site-search .reset-button');
        var $mobileSearchTrigger = $('.js-mobile-search-trigger');
        var $searchContainer = $('.js-search-container');
        var $mobileClpCatNavOpen = $('.js-bbw-cat-nav-open-btn');
        var $mobileClpCatNavClose = $('.js-bbw-cat-nav-close-btn');
        var $mobileClpCatNav = $('.bbw-cat-sidebar-inner');
        var $slotPlpCategoryName = $('.js-bbw-plp-slot-category-name');
        var $categoryPlpName = $('.js-bbw-plp-category-name');

        //show and hide category slot h1 name for plp
        if ($slotPlpCategoryName.children().length !== 0) {
            $slotPlpCategoryName.show();
        } else {
            $categoryPlpName.show();
        }

        $simpleSearch.submit(function (e) {
            var suggestionsList = $('.suggestions .item');
            var $searchForm = $('.search-field');
            if (suggestionsList.filter('.selected').length !== 0) {
                e.preventDefault();
                suggestionsList.filter('.selected').find('a')[0].click();
            }

            if ($searchForm.val().trim() == '') {
                e.preventDefault();
            }

        });

        $searchFields.each(function () {
            /**
             * Use debounce to avoid making an Ajax call on every single key press by waiting a few
             * hundred milliseconds before making the request. Without debounce, the user sees the
             * browser blink with every key press.
             */
            var debounceSuggestions = debounce(getSuggestions, 300);
            $(this).on('keyup focus', function (e) {
                var searchForm = $('.search-field').val();

                if (searchForm.trim() != '') {
                    var $searchBtn = $('.bbw-search-btn');
                    var dataLayer = {
                        'event'       : 'view_search_results',
                        'eventTypes'  : 'hover,click',
                        'search_term' : searchForm.toLowerCase() || ''
                    };
                    $searchBtn.attr('data-cbt', JSON.stringify(dataLayer));
                }

                // Capture Down/Up Arrow Key Events
                switch (e.which) {
                    case DOWN_KEY:
                        handleArrow(DIRECTION_DOWN);
                        e.preventDefault(); // prevent moving the cursor
                        break;
                    case UP_KEY:
                        handleArrow(DIRECTION_UP);
                        e.preventDefault(); // prevent moving the cursor
                        break;
                    default:
                        debounceSuggestions(this, e);
                }
            });
        });

        $body.on('click', function (e) {
            var $suggestions = $('.suggestions');

            if (!$suggestions.has(e.target).length && !$(e.target).hasClass('search-field')) {
                $suggestions.hide();
            }
        });

        $resetButton.on('click', function () {
            var $this = $(this);

            $this.removeClass('d-block');
            $body.removeClass('modal-open');
        });

        //accessibility for enter button on keyboard
        $mobileSearchTrigger.on('keyup', function (event) {
            if (event.which == 13) {
                var $this = $(this);

                $this.trigger('click');
                $this.focus();
            }
        });

        $mobileSearchTrigger.on('click', openMobileSearchOverlay);

        $document.on('viewportchange', function () {
            var $suggestions = $('.suggestions');

            $searchContainer.addClass('d-none').removeClass('bbw-search-opened');

            $suggestions.hide();
            tearDownSuggestions();
            util.removeBackdrop('bbw-search-backdrop');

            $mobileClpCatNav.removeClass('open');
            $body.removeClass('modal-open');
        });

        $mobileClpCatNavOpen.on('click', function () {
            $mobileClpCatNav.addClass('open');
            $body.addClass('modal-open');
        });

        $mobileClpCatNavClose.on('click', function () {
            $mobileClpCatNav.removeClass('open');
            $body.removeClass('modal-open');
        });

    }
};
